import { classNames } from "@helpers/css";

export const explorerSelectClassName = classNames(
  "bg-white text-gray-700 hover:text-gray-800 border border-gray-300 shadow-xs",
  "rounded-sm text-left cursor-default text-sm tracking-tight",
  "flex-1 pl-2 pr-1 py-1 flex items-center gap-1",
);

export const explorerSelectDisabledClassName = classNames(
  "bg-white text-gray-400 hover:text-gray-400 bg-gray-50",
);
